import {CSSProperties, ReactNode, useLayoutEffect, useMemo, useState} from "react";
import ReactModal from "react-modal";
import classNames from "classnames";

import {createResponsiveModalHeightAnimator} from "../../utils/create_responsive_modal_height_animator";
import {ResponsiveModalBody} from "./ResponsiveModalBody";
import {ResponsiveModalCloseButton} from "./ResponsiveModalCloseButton";
import {ResponsiveModalContext} from "./ResponsiveModalContext";
import {ResponsiveModalFooter} from "./ResponsiveModalFooter";
import {ResponsiveModalHeader} from "./ResponsiveModalHeader";

import * as styles from "./ResponsiveModal.module.css";

export const RESPONSIVE_MODAL_ANIMATION_DURATION_MS = 250;

export interface IResponsiveModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAfterOpen?: () => void;
    onAfterClose?: () => void;
    children: ReactNode;
    shouldCloseOnOverlayClick?: boolean;
    shouldCloseOnEsc?: boolean;
    animateHeight?: boolean;
    zIndex?: number;
    contentLabel?: string;
    ariaLabelledBy?: string;
    ariaDescribedBy?: string;
    className?: string;
    overlayClassName?: string;
    dataTestId?: string;
}

export const ResponsiveModal = (props: IResponsiveModalProps) => {
    const {
        isOpen,
        onClose,
        onAfterOpen,
        onAfterClose,
        children,
        shouldCloseOnOverlayClick = true,
        shouldCloseOnEsc = true,
        animateHeight = true,
        zIndex = 9000,
        contentLabel,
        ariaLabelledBy,
        ariaDescribedBy,
        className,
        overlayClassName,
        dataTestId
    } = props;

    const overlayStyle = {zIndex, "--responsive-modal-duration": `${RESPONSIVE_MODAL_ANIMATION_DURATION_MS}ms`} as CSSProperties;

    const [heightAnimator] = useState(() =>
        createResponsiveModalHeightAnimator({durationMs: RESPONSIVE_MODAL_ANIMATION_DURATION_MS, isAnimationEnabled: animateHeight})
    );

    useLayoutEffect(() => {
        heightAnimator.setOpen(isOpen);
    }, [heightAnimator, isOpen]);

    useLayoutEffect(() => {
        heightAnimator.setAnimationEnabled(animateHeight);
    }, [heightAnimator, animateHeight]);

    const contextValue = useMemo(
        () => ({
            onClose: () => {
                if (isOpen) {
                    onClose();
                }
            },
            registerPart: heightAnimator.registerPart
        }),
        [heightAnimator, isOpen, onClose]
    );

    return (
        <ResponsiveModalContext.Provider value={contextValue}>
            <ReactModal
                isOpen={isOpen}
                onRequestClose={contextValue.onClose}
                onAfterOpen={onAfterOpen}
                onAfterClose={onAfterClose}
                closeTimeoutMS={RESPONSIVE_MODAL_ANIMATION_DURATION_MS}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                shouldCloseOnEsc={shouldCloseOnEsc}
                contentLabel={contentLabel}
                aria={{labelledby: ariaLabelledBy, describedby: ariaDescribedBy}}
                ariaHideApp={false}
                bodyOpenClassName="ReactModal__Body--scroll-block"
                className={{
                    base: classNames(styles.panel, className),
                    afterOpen: styles.panelAfterOpen,
                    beforeClose: styles.panelBeforeClose
                }}
                overlayClassName={{
                    base: classNames(styles.overlay, overlayClassName),
                    afterOpen: styles.overlayAfterOpen,
                    beforeClose: styles.overlayBeforeClose
                }}
                style={{overlay: overlayStyle}}
                contentRef={heightAnimator.setPanel}
                testId={dataTestId}
            >
                {children}
            </ReactModal>
        </ResponsiveModalContext.Provider>
    );
};

ResponsiveModal.Header = ResponsiveModalHeader;
ResponsiveModal.Body = ResponsiveModalBody;
ResponsiveModal.Footer = ResponsiveModalFooter;
ResponsiveModal.CloseButton = ResponsiveModalCloseButton;
import {CSSProperties, ReactNode, useLayoutEffect, useMemo, useState} from "react";
import ReactModal from "react-modal";
import classNames from "classnames";

import {createResponsiveModalHeightAnimator} from "../../utils/create_responsive_modal_height_animator";
import {ResponsiveModalBody} from "./ResponsiveModalBody";
import {ResponsiveModalCloseButton} from "./ResponsiveModalCloseButton";
import {ResponsiveModalContext} from "./ResponsiveModalContext";
import {ResponsiveModalFooter} from "./ResponsiveModalFooter";
import {ResponsiveModalHeader} from "./ResponsiveModalHeader";

import * as styles from "./ResponsiveModal.module.css";

export const RESPONSIVE_MODAL_ANIMATION_DURATION_MS = 250;

export interface IResponsiveModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAfterOpen?: () => void;
    onAfterClose?: () => void;
    children: ReactNode;
    shouldCloseOnOverlayClick?: boolean;
    shouldCloseOnEsc?: boolean;
    animateHeight?: boolean;
    zIndex?: number;
    contentLabel?: string;
    ariaLabelledBy?: string;
    ariaDescribedBy?: string;
    className?: string;
    overlayClassName?: string;
    dataTestId?: string;
}

export const ResponsiveModal = (props: IResponsiveModalProps) => {
    const {
        isOpen,
        onClose,
        onAfterOpen,
        onAfterClose,
        children,
        shouldCloseOnOverlayClick = true,
        shouldCloseOnEsc = true,
        animateHeight = true,
        zIndex = 9000,
        contentLabel,
        ariaLabelledBy,
        ariaDescribedBy,
        className,
        overlayClassName,
        dataTestId
    } = props;

    const overlayStyle = {zIndex, "--responsive-modal-duration": `${RESPONSIVE_MODAL_ANIMATION_DURATION_MS}ms`} as CSSProperties;

    const [heightAnimator] = useState(() =>
        createResponsiveModalHeightAnimator({durationMs: RESPONSIVE_MODAL_ANIMATION_DURATION_MS, isAnimationEnabled: animateHeight})
    );

    useLayoutEffect(() => {
        heightAnimator.setOpen(isOpen);
    }, [heightAnimator, isOpen]);

    useLayoutEffect(() => {
        heightAnimator.setAnimationEnabled(animateHeight);
    }, [heightAnimator, animateHeight]);

    const contextValue = useMemo(
        () => ({
            onClose: () => {
                if (isOpen) {
                    onClose();
                }
            },
            registerPart: heightAnimator.registerPart
        }),
        [heightAnimator, isOpen, onClose]
    );

    return (
        <ResponsiveModalContext.Provider value={contextValue}>
            <ReactModal
                isOpen={isOpen}
                onRequestClose={contextValue.onClose}
                onAfterOpen={onAfterOpen}
                onAfterClose={onAfterClose}
                closeTimeoutMS={RESPONSIVE_MODAL_ANIMATION_DURATION_MS}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                shouldCloseOnEsc={shouldCloseOnEsc}
                contentLabel={contentLabel}
                aria={{labelledby: ariaLabelledBy, describedby: ariaDescribedBy}}
                ariaHideApp={false}
                bodyOpenClassName="ReactModal__Body--scroll-block"
                className={{
                    base: classNames(styles.panel, className),
                    afterOpen: styles.panelAfterOpen,
                    beforeClose: styles.panelBeforeClose
                }}
                overlayClassName={{
                    base: classNames(styles.overlay, overlayClassName),
                    afterOpen: styles.overlayAfterOpen,
                    beforeClose: styles.overlayBeforeClose
                }}
                style={{overlay: overlayStyle}}
                contentRef={heightAnimator.setPanel}
                testId={dataTestId}
            >
                {children}
            </ReactModal>
        </ResponsiveModalContext.Provider>
    );
};

ResponsiveModal.Header = ResponsiveModalHeader;
ResponsiveModal.Body = ResponsiveModalBody;
ResponsiveModal.Footer = ResponsiveModalFooter;
ResponsiveModal.CloseButton = ResponsiveModalCloseButton;
